import React from "react";
import { Image, Divider } from 'antd';
import language from "../../resources/languages/fa_IR";

// Components
import Support from "../support"

const { Components: { Safar30 }, App } = language

export default function Index() {

    return (
        <>
            <div className={'safar30-why'}>
                <p>{Safar30.paragraphOne}</p>
                <Image alt={App.title} src={require('../../resources/media/safar30/01.jpg')} />
                <p>{Safar30.paragraphTwo}</p>
                <Image alt={App.title} src={require('../../resources/media/safar30/02.jpg')} />
                <p>{Safar30.paragraphThree}</p>
                <Image alt={App.title} src={require('../../resources/media/safar30/03.jpg')} />
                <p>{Safar30.paragraphFour}</p>
            </div>
            <Divider />
            <Support />
        </>
    )
}
